import { Popover } from "antd";
import { map } from "underscore";
import { ICellRendererParams } from "ag-grid-community";
import { titleCase } from "@ts/utils";
import { TAG_COLORS } from "@ts/constants";

interface ArrayListPopOverRendererProps extends ICellRendererParams {
    field: string;
}

enum TagDef {
    SUBCATEGORY='subcategory',
    CATEGORY='category',
    BRAND='brand'
}
const ArrayListPopOverRenderer = (params: ArrayListPopOverRendererProps) => {
    const data = params.data[params.colDef.field] || [];
    
    const getColors = () => {
        const field = params.colDef.field?.toLowerCase() || '';
        if (field.includes(TagDef.SUBCATEGORY)) {
            return TAG_COLORS[1];
        }
        if (field.includes(TagDef.CATEGORY)) {
            return TAG_COLORS[0];
        }
        if (field.includes(TagDef.BRAND)) {
            return TAG_COLORS[2];
        }
        return { fill: "#64748B", border: "#E2E8F0", background: "#F8FAFC" };
    };

    const colors = getColors();
    const popoverContent = () => (
        <div className="campaigns-tag-popover rounded shadow-sm" style={{ background: "#fff", padding: "8px" }}>
            {map(data, (item: string) => (
                <div
                    key={item}
                    className="rounded d-flex align-items-center"
                    style={{
                        fontSize: "13px",
                        padding: "6px 12px",
                        marginBottom: "4px",
                        background: colors.background,
                        color: colors.fill
                    }}
                >
                    {titleCase(item)}
                </div>
            ))}
        </div>
    );

    return (
        <>
            {params.node.rowPinned ? null : (
                <div className="d-flex align-items-center justify-content-center">
                    <Popover
                        overlayClassName="custom-popover"
                        placement="right"
                        trigger="hover"
                        content={popoverContent}
                    >
                        <div className="d-flex align-items-center" style={{ cursor: "pointer" }}>
                            <div className="ellipsis" style={{ maxWidth: "15ch" }}>
                                {data.length ? titleCase(data[0]) : ""}
                            </div>
                            {data.length > 1 && (
                                <div className="count-indicator ms-1">
                                    +{data.length - 1}
                                </div>
                            )}
                        </div>
                    </Popover>
                </div>
            )}
        </>
    );
};

export default ArrayListPopOverRenderer;